"use client"

import { useEffect } from "react"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { JobListPage } from "./pages/CommonPublicPages/Basic/JobListPage"
import { ChakraProvider } from "@chakra-ui/react"
import { Notify } from "./pages/CommonPublicPages/Basic/Notify"
import { MyReviewsPage } from "./pages/CommonPublicPages/Basic/MyReviewsPage"
import { CompanyListPage } from "./pages/CommonPublicPages/CompanyPages/CompanyListPage"
import { ThankYou } from "./features/notif&msg/thankYou"
import CandDash from "./pages/Dashboards/CandDash"
import ShortlistedJobs from "./features/candidateDashboard/components/shortlistedJobs"
import { Profile } from "./features/profile/Profile"
import AppliedJobs from "./features/candidateDashboard/components/AppliedJobs"
import AboutPage from "./pages/Candidates/ProfileCreation/AboutPage"
import LeftSection from "./features/CandProfCreation/CandidateProf"
import WorkPlace from "./features/CandProfCreation/components/WorkPlace"
import MissingDetails from "./features/profile/components/MissingDetails"
import CandSubscriptionBilling from "./features/candidateDashboard/components/CandSubs&Billing"
import { JobSingle } from "./features/jobApply/JobSingle"
import ComapanyVerif2 from "./features/CompVerif/CompVerif2"
import EducationshowPage from "./features/candidateDashboard/components/EducationShow"
import ExperienceShow from "./features/candidateDashboard/components/ExperienceShow"
import Education from "./features/CandProfCreation/components/Education"
import Experience from "./features/CandProfCreation/components/Experience"
import CandSettings from "./features/Settings/CandSettings/CandSettings"
import { JobPosting } from "./features/AdminPanel/AdminDashboard/components/JobPostings"
import JobTitlesList from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobTitlesList"
import JobTypesList from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobTypesList"
import JobPostLocations from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobPostLocations"
import { JobShifts } from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobShifts"
import JobTimeline from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobTimeline"
import MinmQualif from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/MinmQualif"
import TotalExperience from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/TotalExperience"
import ReqdSkills from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/ReqdSkills"
import CandidateList from "./features/AdminPanel/AdminDashboard/components/CandidateUserList"
import EmployerList from "./features/AdminPanel/AdminDashboard/components/EmployerUserList"
import ViewSubscriptions from "./features/AdminPanel/AdminDashboard/components/ViewSubscriptions"
import Account from "./features/Settings/CandSettings/component/Account"
import Email from "./features/Settings/CandSettings/component/Email"
import Privacy from "./features/Settings/CandSettings/component/Privacy"
import HomeLoggedIn from "./pages/CommonPublicPages/Home/HomeLoggedIn"
import PhoneVerifCandidate from "./features/login/PhoneVerifCandidate"
import CandRegVerif from "./features/login/CandRegVerif"
import Guidance from "./features/careerAdvice/Guidance"
import { CompanySinglePage } from "./pages/CommonPublicPages/CompanyPages/companySinglePage"
import JobDepartments from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobDepartments"
import JobEducationCourse from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobEducationCourse"
import ExampleList2 from "./features/AdminPanel/JobPostingSlice/ExampleList2"
import { ExampleReview } from "./features/AdminPanel/JobPostingSlice/ExampleReview"
import CityList from "./features/AdminPanel/AdminDashboard/components/CityList"
import { useDispatch } from "react-redux"
import { fetchTokenAsync } from "./features/common/FetchTokenSlice"
import HomePage from "./pages/CommonPublicPages/Home/HomePage"
import JobCompanyList from "./features/AdminPanel/AdminDashboard/components/JobCompanyList"
import ProtectedRoute from "./features/common/ProtectedRoute"
import AdminDashboard from "./pages/Dashboards/AdminDashboard"
import LoginPage from "./pages/CommonPublicPages/LoginSignupPage/LoginPage"
import SignupPage from "./pages/CommonPublicPages/LoginSignupPage/SignupPage"
import DummyPage from "./pages/CommonPublicPages/Navbars/components/DummyPage"
import CandidateSkills from "./features/candidateDashboard/components/Skills"
import { PublicJobDetailPage } from "./features/candidateDashboard/candidateSlice/candidateJobApply/JobSinglePage2"
import { JobByRolesPage } from "./features/jobList/PopularJobRolesList/JobRolesPage"
import { JobByCategoriesPage } from "./features/jobList/PopularJobCategoriesList/JobCategoriesPage"
import JobSearch2 from "./features/jobSearch/jobSearch2"
import CandidateSearchHistory from "./features/jobSearch/CandidateJobSearchHistory/CandidateSearchHistory"
import Testing from "./features/AdminPanel/Testimonials/Testing"
import ITSkills from "./features/CandProfCreation/components/ITskills"
import JobEducationCourseSpecialty from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/JobEducationCourseSpecialty"
import Languages from "./features/CandProfCreation/CandidateProfileSlice/Language/Languages"
import GlobalErrorBoundary from "./features/common/GlobalErrorBoundary"
import CoreIndustry from "./features/AdminPanel/AdminDashboard/components/JobPostingComp/CoreIndustry"
import SubscriberList from "./features/AdminPanel/AdminDashboard/components/SubscriberList"
import AllSubscriptions from "./features/AdminPanel/AdminDashboard/components/AllSubscriptions"
import AdminReviews from "./features/AdminPanel/AdminDashboard/components/AdminReviews"
import { AdminJobList } from "./features/AdminPanel/JobList/AdminJobList"
import PhoneVerification from "./features/auth/components/PhoneVerif"
import ResumeDashboard from "./features/Public/PublicResume/ResumeDashboard"
import JobSearch from "./features/jobSearch/Suggestions/Suggestions"
import HoverDropdown from "./features/AdminPanel/JobPostingSlice/ExampleList"
import AboutUs from "./features/Public/RawData/AboutUs"
import PrivacyPolicy from "./features/Public/RawData/PrivacyPolicy"
import RefundPolicy from "./features/Public/RawData/RefundPolicy"
import CoreValues from "./features/Public/RawData/CoreValues"
import Version from "./pages/version/Version"
import HelpCenter from "./features/Public/RawData/ContactUs"
import EmailForm from "./features/auth/components/PasswordResetRequest"
import PasswordResetForm from "./features/auth/components/PasswordReset"
import UpdatePasswordForm from "./features/auth/components/ChangePassword"
import VerifyEmailButton from "./features/auth/components/EmailVerification"
import VerifiedPage from "./features/auth/components/EmailVerifyConfirmation"
import SubscriptionDashboard from "./features/candidateDashboard/candidateSlice/PaymentGateway/CandidateSubscriptionHistory"
import SubscriptionPlan from "./features/candidateDashboard/components/CandSubs&Billing"
import PaymentInitiate from "./features/candidateDashboard/candidateSlice/PaymentGateway/PaymentInitiate"
import NotificationTable from "./features/AdminPanel/AdminDashboard/components/Notifications"
import JobCityList from "./features/AdminPanel/AdminDashboard/components/JobCityList"
import CountryList from "./features/AdminPanel/Address/CountryList/CountryList"
import StateList from "./features/AdminPanel/Address/StateList/StateList"
import CandidateSubscriberList from "./features/AdminPanel/AdminDashboard/components/CandidateSubscriberList"
import RecommendedJobs from "./features/candidateDashboard/components/RecommendedJobs"
import CandidatePublicSubscription from "./features/CandidatePublicSubscription/CandidatePublicSubscription"
import TextEditor from "./features/jobSearch/TextEditor"
import AdminProfile2 from "./features/AdminPanel/AdminDashboard/components/AdminProfile2"
import ContactUsAdmin from "./features/AdminPanel/AdminDashboard/components/ContactUsAdmin"
import ContactUsHome from "./features/ContactUsHome/ContactUsHome"
import NotFound404 from "./pages/CommonPublicPages/Basic/NotFound404"
import AdminResumeBuilder from "./features/AdminPanel/AdminDashboard/components/AdminResumeBuilder"
import PhoneVerification2 from "./features/auth/components/PhoneVerification2"
import AdminSubscriptionTopUp from "./features/AdminPanel/AdminDashboard/components/AdminSubscriptionTopUp"
import InterviewPreparation from "./features/candidateDashboard/components/InterviewPreparation"
import SkillsDevelopment from "./features/candidateDashboard/components/SkillsDevelopment"
import ResumeBuilderHomePage from "./pages/CommonPublicPages/ResumeBuilderHome/ResumeBuilderHomePage"
import SkillDevelopmentAdmin from "./features/AdminPanel/AdminDashboard/components/SkillDevelopmentAdmin"
import InterviewPreparationAdmin from "./features/AdminPanel/AdminDashboard/components/InterviewPreparationAdmin"
import CareerAdviceAdmin from "./features/AdminPanel/AdminDashboard/components/CareerAdviceAdmin"
import CareerAdvice from "./features/candidateDashboard/components/CareerAdvice"
import Blogs from "./features/HomeAfterLogin.js/Blogs/Blogs"
import PhoneVerification2Phone from "./features/auth/components/PhoneVerification2Phone"

// Enhanced error boundary wrapper for router
const RouterErrorBoundary = ({ children }) => {
  return <GlobalErrorBoundary>{children}</GlobalErrorBoundary>
}

// Error fallback component for router-level errors
const RouterErrorFallback = () => {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f8f9fa",
      padding: "20px",
      fontFamily: "Arial, sans-serif"
    }}>
      <div style={{
        textAlign: "center",
        padding: "40px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        maxWidth: "600px",
        width: "100%",
        border: "1px solid #e9ecef"
      }}>
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>🔄</div>
        <h1 style={{
          fontSize: "28px",
          fontWeight: "bold",
          color: "#dc3545",
          marginBottom: "16px"
        }}>
          Navigation Error
        </h1>
        <p style={{
          fontSize: "16px",
          marginBottom: "24px",
          color: "#6c757d",
          lineHeight: "1.5"
        }}>
          There was an error with page navigation. Please try refreshing or go back to the home page.
        </p>
        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: "#dc3545",
              color: "white",
              padding: "12px 24px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              minWidth: "120px"
            }}
          >
            Reload Page
          </button>
          <button
            onClick={() => window.location.href = "/"}
            style={{
              backgroundColor: "#6c757d",
              color: "white",
              padding: "12px 24px",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
              minWidth: "120px"
            }}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <GlobalErrorBoundary>
        <DummyPage />
      </GlobalErrorBoundary>
    ),
    errorElement: <RouterErrorFallback />,
    children: [
      {
        index: true,
        element: (
          <GlobalErrorBoundary>
            <HomePage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/reset-code-request",
        element: (
          <GlobalErrorBoundary>
            <EmailForm />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/password-reset",
        element: (
          <GlobalErrorBoundary>
            <PasswordResetForm />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/.well-known/assetlinks.json",

      },
      {
        path: "/job-search",
        element: (
          <GlobalErrorBoundary>
            <JobSearch />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/company-list",
        element: (
          <GlobalErrorBoundary>
            <CompanyListPage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/resume-builder",
        element: (
          <GlobalErrorBoundary>
            <ResumeBuilderHomePage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/texteditor",
        element: (
          <GlobalErrorBoundary>
            <TextEditor />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: `/company-list/:uuid`,
        element: (
          <GlobalErrorBoundary>
            <CompanySinglePage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/job-desc",
        element: (
          <GlobalErrorBoundary>
            <JobSingle />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/jobs",
        element: (
          <GlobalErrorBoundary>
            <JobListPage />
          </GlobalErrorBoundary>
        ),
      },
      // {
      //   path: "/pricing",
      //   element: (
      //     <GlobalErrorBoundary>
      //       <CandidatePublicSubscription />
      //     </GlobalErrorBoundary>
      //   ),
      // },
      {
        path: "/blogs",
        element: (
          <GlobalErrorBoundary>
            <Blogs />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/jobs/:uuid",
        element: (
          <GlobalErrorBoundary>
            <PublicJobDetailPage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/jobs-roles/:uuid",
        element: (
          <GlobalErrorBoundary>
            <JobByRolesPage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "/job-categories/:uuid",
        element: (
          <GlobalErrorBoundary>
            <JobByCategoriesPage />
          </GlobalErrorBoundary>
        ),
      },
      // candidate dashboard

    ],
  },
  {
    path: "/candidate-dashboard/",
    element: (
      <GlobalErrorBoundary>
        <ProtectedRoute role="candidate">
          <CandDash />
        </ProtectedRoute>
      </GlobalErrorBoundary>
    ),
    children: [
      {
        index: true,
        element: (
          <GlobalErrorBoundary>
            <Profile />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "saved-jobs",
        element: (
          <GlobalErrorBoundary>
            <ShortlistedJobs />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "candSubsBill",
        element: (
          <GlobalErrorBoundary>
            <CandSubscriptionBilling />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "experience",
        element: (
          <GlobalErrorBoundary>
            <ExperienceShow />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "support",
        element: (
          <GlobalErrorBoundary>
            <HelpCenter />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "education",
        element: (
          <GlobalErrorBoundary>
            <EducationshowPage />
          </GlobalErrorBoundary>
        ),
      },
      // {
      //   path: "subscription-billings",
      //   element: (
      //     <GlobalErrorBoundary>
      //       <SubscriptionDashboard />
      //     </GlobalErrorBoundary>
      //   ),
      // },
      // {
      //   path: "subscription-plan",
      //   element: (
      //     <GlobalErrorBoundary>
      //       <SubscriptionPlan />
      //     </GlobalErrorBoundary>
      //   ),
      // },
      {
        path: "resume",
        element: (
          <GlobalErrorBoundary>
            <ResumeDashboard />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "missingDetails",
        element: (
          <GlobalErrorBoundary>
            <MissingDetails />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "recommended-jobs",
        element: (
          <GlobalErrorBoundary>
            <RecommendedJobs />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "applied-jobs",
        element: (
          <GlobalErrorBoundary>
            <AppliedJobs />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "skills",
        element: (
          <GlobalErrorBoundary>
            <CandidateSkills />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "interview-preparation",
        element: (
          <GlobalErrorBoundary>
            <InterviewPreparation />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "skill-development",
        element: (
          <GlobalErrorBoundary>
            <SkillsDevelopment />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "career-advice",
        element: (
          <GlobalErrorBoundary>
            <CareerAdvice />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "change-password",
        element: (
          <GlobalErrorBoundary>
            <ProtectedRoute role="candidate">
              <UpdatePasswordForm />
            </ProtectedRoute>
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "verify-email",
        element: (
          <GlobalErrorBoundary>
            <ProtectedRoute role="candidate">
              <VerifyEmailButton />
            </ProtectedRoute>
          </GlobalErrorBoundary>
        ),
      },

      {
        path: "settings",
        element: (
          <GlobalErrorBoundary>
            <CandSettings />
          </GlobalErrorBoundary>
        ),
        children: [
          {
            index: true,
            element: (
              <GlobalErrorBoundary>
                <Account />
              </GlobalErrorBoundary>
            ),
          },
          {
            path: "email-setting",
            element: (
              <GlobalErrorBoundary>
                <Email />
              </GlobalErrorBoundary>
            ),
          },
          {
            path: "privacy-settings",
            element: (
              <GlobalErrorBoundary>
                <Privacy />
              </GlobalErrorBoundary>
            ),
          },
        ],
      },
    ],
  },

  {
    path: "verify-email/:token",
    element: (
      <GlobalErrorBoundary>

        <VerifiedPage />

      </GlobalErrorBoundary>
    ),
  },

  {
    path: "/success-page",
    element: (
      <GlobalErrorBoundary>
        <PaymentInitiate />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/version",
    element: (
      <GlobalErrorBoundary>
        <Version />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/login",
    element: (
      <GlobalErrorBoundary>
        <LoginPage />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/history",
    element: (
      <GlobalErrorBoundary>
        <CandidateSearchHistory />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/testing",
    element: (
      <GlobalErrorBoundary>
        <Testing />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/jobSearch2",
    element: (
      <GlobalErrorBoundary>
        <JobSearch2 />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/candidate-profile/",
    element: (
      <GlobalErrorBoundary>
        <ProtectedRoute role="candidate">
          <LeftSection />
        </ProtectedRoute>
      </GlobalErrorBoundary>
    ),
    children: [
      {
        index: true,
        element: (
          <GlobalErrorBoundary>
            <AboutPage />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "education",
        element: (
          <GlobalErrorBoundary>
            <Education />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "experience",
        element: (
          <GlobalErrorBoundary>
            <Experience />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "skills",
        element: (
          <GlobalErrorBoundary>
            <ITSkills />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "language",
        element: (
          <GlobalErrorBoundary>
            <Languages />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "job-preferences",
        element: (
          <GlobalErrorBoundary>
            <WorkPlace />
          </GlobalErrorBoundary>
        ),
      },
    ],
  },
  {
    path: "/admin-dashboard/",
    element: (
      <GlobalErrorBoundary>
        <ProtectedRoute role={"admin"}>
          <AdminDashboard />
        </ProtectedRoute>
      </GlobalErrorBoundary>
    ),
    children: [
      {
        index: true,
        element: (
          <GlobalErrorBoundary>
            <AdminProfile2 />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobPosting",
        element: (
          <GlobalErrorBoundary>
            <JobPosting />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "notifications",
        element: (
          <GlobalErrorBoundary>
            <NotificationTable />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "admin-resume-builder",
        element: (
          <GlobalErrorBoundary>
            <AdminResumeBuilder />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "contact-us-admin",
        element: (
          <GlobalErrorBoundary>
            <ContactUsAdmin />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "createplan",
        element: (
          <GlobalErrorBoundary>
            <AllSubscriptions />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "subscription-topup",
        element: (
          <GlobalErrorBoundary>
            <AdminSubscriptionTopUp />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "core-industry",
        element: (
          <GlobalErrorBoundary>
            <CoreIndustry />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobTitles",
        element: (
          <GlobalErrorBoundary>
            <JobTitlesList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobTypes",
        element: (
          <GlobalErrorBoundary>
            <JobTypesList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobDepartments",
        element: (
          <GlobalErrorBoundary>
            <JobDepartments />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobEducationCourse",
        element: (
          <GlobalErrorBoundary>
            <JobEducationCourse />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobEducationCourseSpecialty",
        element: (
          <GlobalErrorBoundary>
            <JobEducationCourseSpecialty />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "companyList",
        element: (
          <GlobalErrorBoundary>
            <JobCompanyList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "adminJobs",
        element: (
          <GlobalErrorBoundary>
            <AdminJobList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "cityList",
        element: (
          <GlobalErrorBoundary>
            <JobCityList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "city",
        element: (
          <GlobalErrorBoundary>
            <CityList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "country",
        element: (
          <GlobalErrorBoundary>
            <CountryList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "state",
        element: (
          <GlobalErrorBoundary>
            <StateList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "testimonials",
        element: (
          <GlobalErrorBoundary>
            <Testing />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobPostLocations",
        element: (
          <GlobalErrorBoundary>
            <JobPostLocations />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobShifts",
        element: (
          <GlobalErrorBoundary>
            <JobShifts />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobTimeline",
        element: (
          <GlobalErrorBoundary>
            <JobTimeline />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobMinmQualif",
        element: (
          <GlobalErrorBoundary>
            <MinmQualif />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "jobEducation",
        element: (
          <GlobalErrorBoundary>
            <MinmQualif />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "totalExpMinm",
        element: (
          <GlobalErrorBoundary>
            <TotalExperience />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "reqdSkills",
        element: (
          <GlobalErrorBoundary>
            <ReqdSkills />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "candidateProfile",
        element: (
          <GlobalErrorBoundary>
            <CandidateList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "employersProfile",
        element: (
          <GlobalErrorBoundary>
            <EmployerList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "subscriber-list-employer",
        element: (
          <GlobalErrorBoundary>
            <SubscriberList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "subscriber-list-candidate",
        element: (
          <GlobalErrorBoundary>
            <CandidateSubscriberList />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "viewSubscriptions",
        element: (
          <GlobalErrorBoundary>
            <ViewSubscriptions />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "reviews",
        element: (
          <GlobalErrorBoundary>
            <AdminReviews />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "skill-developement-admin",
        element: (
          <GlobalErrorBoundary>
            <SkillDevelopmentAdmin />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "interview-preparation-admin",
        element: (
          <GlobalErrorBoundary>
            <InterviewPreparationAdmin />
          </GlobalErrorBoundary>
        ),
      },
      {
        path: "career-advice-admin",
        element: (
          <GlobalErrorBoundary>
            <CareerAdviceAdmin />
          </GlobalErrorBoundary>
        ),
      },
    ],
  },
  {
    path: "/signup",
    element: (
      <GlobalErrorBoundary>
        <SignupPage />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/resume",
    element: (
      <GlobalErrorBoundary>
        <ResumeDashboard />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/example2",
    element: (
      <GlobalErrorBoundary>
        <ExampleList2 />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/about-us",
    element: (
      <GlobalErrorBoundary>
        <AboutUs />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/core-values",
    element: (
      <GlobalErrorBoundary>
        <CoreValues />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <GlobalErrorBoundary>
        <PrivacyPolicy />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <GlobalErrorBoundary>
        <ContactUsHome />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/refund-policy",
    element: (
      <GlobalErrorBoundary>
        <RefundPolicy />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/example3",
    element: (
      <GlobalErrorBoundary>
        <ExampleReview />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/example",
    element: (
      <GlobalErrorBoundary>
        <HoverDropdown />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/phone-verification",
    element: (
      <GlobalErrorBoundary>
        <PhoneVerification2 />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/phone-verification-phone",
    element: (
      <GlobalErrorBoundary>
        <PhoneVerification2Phone />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/notify",
    element: (
      <GlobalErrorBoundary>
        <Notify />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/phoneverifcandidate",
    element: (
      <GlobalErrorBoundary>
        <PhoneVerifCandidate />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/candregverif",
    element: (
      <GlobalErrorBoundary>
        <CandRegVerif />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/myreviews",
    element: (
      <GlobalErrorBoundary>
        <MyReviewsPage />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/careerAdvice",
    element: (
      <GlobalErrorBoundary>
        <Guidance />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/thanku",
    element: (
      <GlobalErrorBoundary>
        <ThankYou />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "/compVerif2",
    element: (
      <GlobalErrorBoundary>
        <ComapanyVerif2 />
      </GlobalErrorBoundary>
    ),
  },
  {
    path: "*",
    element: (
      <GlobalErrorBoundary>
        <NotFound404 />
      </GlobalErrorBoundary>
    ),
  },
])

// Global error handling for unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  console.warn("Suppressed Promise Rejection:", event.reason)
  event.preventDefault()
})

// Global error handling for runtime errors
window.addEventListener("error", (event) => {
  console.warn("Suppressed Error:", event.message)
  event.preventDefault()
})

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchTokenAsync())
  }, [dispatch])

  return (
    <div className="App">
      <ChakraProvider>
        <GlobalErrorBoundary>
          <RouterProvider router={router} />
        </GlobalErrorBoundary>
      </ChakraProvider>
    </div>
  )
}

export default App